import * as React from 'react';

import MobileMenuConfigWrapper from 'bundles/composable-page-header/components/grid-items/mobile/MobileMenuConfigWrapper';
import BrowseFreeCoursesMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/BrowseFreeCoursesMenuItem';
import CourseraPlusMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/CourseraPlusMenuItem';
import WrappedExploreCustomConsumerSubmenu from 'bundles/composable-page-header/components/mobile-menu-items/ExploreCustomConsumerSubmenu';
import ExploreMenuItems from 'bundles/composable-page-header/components/mobile-menu-items/ExploreMenuItems';
import GetAppMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/GetAppMenuItem';
import MetaNavMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MetaNavMenuItem';
import MobileAuthMenuItem from 'bundles/composable-page-header/components/mobile-menu-items/MobileAuthMenuItem';
import {
  MOBILE_EXPLORE_IDENTIFIER,
  MOBILE_MAIN_IDENTIFIER,
  logInButtonProps,
  signUpButtonProps,
} from 'bundles/composable-page-header/constants';
import { getShouldShowCourseraPlusEntrypointInNav } from 'bundles/coursera-plus-common/utils/subscriptionsForwardDiscoveryExperiment';

type Props = {
  showDiscoveryElements?: boolean;
};

const DefaultLoggedOutMobileMenuConfig = ({ showDiscoveryElements = true }: Props) => {
  const showCPlusLink = getShouldShowCourseraPlusEntrypointInNav();

  return (
    <MobileMenuConfigWrapper
      subPagesMap={{
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_ROLES_MENU]: (
          <WrappedExploreCustomConsumerSubmenu identifier={MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_ROLES_SUBMENU} />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_CATEGORIES_MENU]: (
          <WrappedExploreCustomConsumerSubmenu
            identifier={MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_CATEGORIES_SUBMENU}
          />
        ),
        [MOBILE_MAIN_IDENTIFIER.EXPLORE_SKILLS_MENU]: (
          <WrappedExploreCustomConsumerSubmenu identifier={MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_SKILLS_SUBMENU} />
        ),
        [MOBILE_MAIN_IDENTIFIER.EARN_PROFESSIONAL_CERTIFICATE_MENU]: (
          <WrappedExploreCustomConsumerSubmenu
            identifier={MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_PROFESSIONAL_CERTIFICATE_SUBMENU}
          />
        ),
        [MOBILE_MAIN_IDENTIFIER.EARN_ONLINE_DEGREE_MENU]: (
          <WrappedExploreCustomConsumerSubmenu
            identifier={MOBILE_EXPLORE_IDENTIFIER.CONSUMER_EXPLORE_ONLINE_DEGREE_SUBMENU}
          />
        ),
      }}
    >
      {showDiscoveryElements && (
        <React.Fragment>
          <ExploreMenuItems /> <BrowseFreeCoursesMenuItem />
        </React.Fragment>
      )}
      {showCPlusLink && <CourseraPlusMenuItem /> /* Do not add to enterprise header */}
      <MetaNavMenuItem />
      <GetAppMenuItem />
      <MobileAuthMenuItem buttons={[signUpButtonProps(), logInButtonProps()]} />
    </MobileMenuConfigWrapper>
  );
};

export default DefaultLoggedOutMobileMenuConfig;
